import { makeStyles } from '@material-ui/core/styles'

const mainPadding = '4.688rem 0.625rem'
const smallFont = 14
const mainMargin = 16
const sectionPadding = '9.375rem 7.5rem'
const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#FFF',
    padding: sectionPadding,
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      padding: mainPadding,
    },
  },
  gridWrapper: {
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      padding: mainPadding,
    },
  },
  imgWrapper: {
    width: '100%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      marginBottom: mainMargin,
    },
  },
  sketchImage: {
    width: '100%',
    height: '50%',
    display: 'block',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      width: '100%',
      height: '45%',
    },
  },

  gridItem: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
    },
  },
  /* Typography */
  overline: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
    letterSpacing: 1.5,
    fontSize: smallFont,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  heading: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      textAlign: 'center',
    },
    maxWidth: '100%',
    fontSize: 48,
    fontFamily: 'roosevelt02',
  },
  body: {
    [theme.breakpoints.up('md')]: {
      width: 485,
    },
    fontSize: 16,
    lineHeight: '1.5rem',
    color: '#000',
    opacity: '80%',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
}))

export default useStyles
